export default "__VITE_ASSET__DazZuZnK__"